"use strict";

exports.__esModule = true;
exports.default = void 0;
var _constants = require("./constants");
var initialState = {
  previousStatus: null,
  status: _constants.AUTH_STATUS_UNAUTHENTICATED,
  error: null,
  session: null
};
var authReducer = function authReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }
  switch (action.type) {
    case _constants.AUTH_REQUEST_ACTION_TYPE:
      return Object.assign({}, state, {
        previousStatus: state.status,
        status: _constants.AUTH_STATUS_AUTHENTICATING,
        error: null
      });
    case _constants.AUTH_REQUEST_SUCCESS_ACTION_TYPE:
      return Object.assign({}, state, {
        previousStatus: state.status,
        status: _constants.AUTH_STATUS_AUTHENTICATED,
        session: action.payload,
        error: null
      });
    case _constants.AUTH_REQUEST_ERROR_ACTION_TYPE:
      return Object.assign({}, state, {
        previousStatus: state.status,
        status: _constants.AUTH_STATUS_UNAUTHENTICATED,
        error: action.payload,
        session: null
      });
    case _constants.AUTH_REFRESH_SUCCESS_ACTION_TYPE:
      return Object.assign({}, state, {
        previousStatus: state.status,
        status: _constants.AUTH_STATUS_AUTHENTICATED,
        session: Object.assign({}, state.session, action.payload),
        error: null
      });
    default:
      return state;
  }
};
var _default = exports.default = authReducer;